import { render, staticRenderFns } from "./platuserprocess.vue?vue&type=template&id=62480e99&"
import script from "./platuserprocess.vue?vue&type=script&lang=js&"
export * from "./platuserprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports